export const BRAND_MARK_URL = '/brand-mark.png'
export const APP_ENTRY_URL = 'https://q.avelia.chat'
